/* eslint-disable */

import React, { useContext } from 'react';
import { AppBar, Box, useTheme, useMediaQuery } from '@mui/material';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import inetlogo2 from '../../assets/images/inetlogo2.png';

export default function NavbarPaymentOptions({
  openMobile,
  onMobileNavOpen,
  onMobileNavClose,
  companyName,
  companyImage,
}) {
  const { handleSignout } = useContext(PassportAuth);
  const userName = getStorage('username');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{ height: '68px', background: '#f5f5f5' }}>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="fixed"
            sx={{ height: '68px', background: '#f5f5f5' }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: 2,
              }}
            >
              {/* Left logo */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={inetlogo2}
                  alt="inetlogo2"
                  style={{ height: isMobile ? '70px' : '70px' }}
                />
              </Box>

              {/* Right company name and image */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {companyImage && (
                  <img
                    src={`data:image/png;base64,${companyImage}`}
                    alt="Company Logo"
                    style={{ height: isMobile ? '35px' : '45px' }}
                  />
                )}
                <span className="ml-6" />
                <div
                  className="uppercase py-1 text-sm"
                  style={{
                    color: '#474343',
                    fontSize: isMobile ? '15px' : '18px',
                    fontWeight: 'bold',
                    marginTop: isMobile ? '5px' : '0',
                    marginLeft: isMobile ? '-10px' : '0px',
                  }}
                >
                  {companyName}
                </div>
              </Box>
            </Box>
          </AppBar>
        </Box>
      </AppBar>
    </Box>
  );
}
